import React, { memo, useMemo, useCallback } from "react";
import { Table, OverlayTrigger, Tooltip } from "react-bootstrap";
import DomainIcon from "../../../../assets/EmployeeProfileIcons/Profile_Page_Icons/Domain.svg";
import DomainDetailsIcon from "../../../../assets/EmployeeProfileIcons/Profile_Page_Icons/Domain_Details.svg";
import ClientIcon from "../../../../assets/EmployeeProfileIcons/Profile_Page_Icons/client.svg";
import ActionIcon from "../../../../assets/EmployeeProfileIcons/Profile_Page_Icons/Action.svg";

const EmpDomainComponent = memo(({
  data = [],
  canEdit = false,
  onEdit,
  noDataMessage = "No Domain Data Available",
}) => {
  const columns = useMemo(() => [
    { 
      key: "Domain", 
      label: "Domain", 
      icon: DomainIcon,
      width: "30%"
    },
    { 
      key: "DomainDetails", 
      label: "Domain Details", 
      icon: DomainDetailsIcon,
      width: "30%"
    },
    { 
      key: "ClientName", 
      label: "Client Name", 
      icon: ClientIcon,
      width: "30%"
    },
    { 
      key: "action", 
      label: "Action", 
      icon: ActionIcon, 
      isAction: true,
      width: "10%"
    },
  ], []);

  const renderTooltip = useCallback((text) => <Tooltip>{text}</Tooltip>, []);

  const renderCellContent = useCallback((text) => {
    const displayText = text || "";
    return (
      <OverlayTrigger
        placement="top"
        overlay={renderTooltip(displayText)}
      >
        <span 
          className="d-inline-block text-truncate fixed-width-column" 
          style={{ 
            maxWidth: "100%",
            display: 'inline-block'
          }}
        >
          {displayText}
        </span>
      </OverlayTrigger>
    );
  }, [renderTooltip]);

  const handleEditClick = useCallback((item) => {
    if (canEdit && onEdit) {
      onEdit(item);
    }
  }, [canEdit, onEdit]);

  return (
    <div className="domain-table-container">
      <style>
        {`
          .domain-table-container {
            width: 100%;
            overflow-x: auto;
            -webkit-overflow-scrolling: touch;
          }
          
          .fixed-domain-table {
            table-layout: fixed;
            width: 100%;
            min-width: 600px; /* Minimum width to ensure columns don't collapse */
          }
          
          .fixed-width-column {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          
          @media (min-width: 992px) {
            .fixed-domain-table {
              min-width: 100%;
            }
          }
          
          .tech-icon {
            width: 20px;
            height: 20px;
          }
        `}
      </style>
      
      <Table striped bordered hover className="fixed-domain-table">
        <colgroup>
          {columns.map(column => (
            <col key={column.key} style={{ width: column.width }} />
          ))}
        </colgroup>
        <thead className="text-center">
          <tr>
            {columns.map((column) => (
              <th 
                key={column.key}
                style={{ width: column.width }}
              >
                <div className="d-flex flex-column align-items-center fixed-width-column">
                  <div>
                    <img
                      src={column.icon}
                      alt={column.label}
                      className="tech-icon"
                    />
                  </div>
                  <div style={{ fontSize: "12px" }}>{column.label}</div>
                </div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((item, index) => (
              <tr key={index}>
                {columns.map((column) => {
                  if (column.isAction) {
                    return (
                      <td 
                        key={column.key} 
                        className="text-center fixed-width-column"
                        style={{ width: column.width }}
                      >
                        <OverlayTrigger
                          placement="top"
                          overlay={<Tooltip>{canEdit ? "Edit" : "Edit disabled"}</Tooltip>}
                        >
                          <span
                            onClick={() => handleEditClick(item)}
                            style={{
                              cursor: canEdit ? "pointer" : "not-allowed",
                              opacity: canEdit ? 1 : 0.5,
                            }}
                          >
                            <i className="bi bi-pencil-square"></i>
                          </span>
                        </OverlayTrigger>
                      </td>
                    );
                  }
                  
                  return (
                    <td 
                      key={column.key}
                      className="fixed-width-column"
                      style={{ width: column.width }}
                    >
                      {renderCellContent(item[column.key])}
                    </td>
                  );
                })}
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={columns.length} className="text-center">
                {noDataMessage}
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
});

export default EmpDomainComponent;